const config = {
//   API_URL: process.env.REACT_APP_ADS_REPORT_BE_API_URL,
  API_URL: 'https://ads-report.zalopay.vn/api',
  endpoints: {
    auth: {
      login: "/auth/login",
      microsoft: "/login",
      passwordLogin: "/passwordlogin",
      ldapLogin: "/ldaplogin",
      login365: '/login365',
    },
    report: {
      getMenus: "/report/ads/getMenus",
      getDashboardUrl: "/report/ads/getDashboardUrl",
    },
  },
};

export default config;
